import { Injectable } from '@angular/core';

import { MyBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { UserService } from '@frontend/sports/user/feature';

@Injectable()
export class AssociatedAccountService {
    constructor(
        private mybetsConfig: MyBetsConfig,
        private userService: UserService,
    ) {}

    getAssociatedAccount(): Nullable<string> {
        if (!this.mybetsConfig.showAssociatedAccount || !this.userService.isAuthenticated) {
            return null;
        }

        return this.userService.associatedAccount ?? null;
    }
}
